import Splide from "@splidejs/splide";


//keep one example main hero slider 

document.addEventListener("DOMContentLoaded", function () {
  const mainSlider = document.getElementById("main_hero_slider");

  const popularProductsSlider = document.getElementById(
    "popular-products-slider"
  );

  const singleProductSlider = document.getElementById("single-product-slider");
  const singleThumbnailProductSlider = document.getElementById(
    "single-thumbnail-slider"
  );

  const latestPostsSlider = document.getElementById("latest-posts-slider");

  const archiveSlider = document.getElementById(
    "help-and-advice-archive-slider"
  );

  if (mainSlider) {
    const main = new Splide(mainSlider, {
      type: "fade",
      perPage: 1,
      perMove: 1,
      gap: 10,
      focus: "center",
      rewind: true,
      pagination: true,
      arrows: false,
      breakpoints: {
        768: {
          focus: 0,
          gap: 0,
          trimSpace: true,
        },
      },
    });

    const thumbnails = new Splide("#main_hero_thumbnail", {
      fixedWidth: 150,
      fixedHeight: 150,
      gap: 10,
      // focus: "center",
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      // breakpoints: {
      //   600: {
      //     fixedWidth: 60,
      //     fixedHeight: 44,
      //   },
      // },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }

  if (popularProductsSlider) {
    const popularProducts = new Splide(popularProductsSlider, {
      type: "fade",
      perPage: 1,
      perMove: 1,
      gap: 10,
      focus: "center",
      rewind: true,
      arrows: false,
      pagination: true,
      mediaQuery: "min",
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }

  if (singleProductSlider && singleThumbnailProductSlider) {
    const productSliderSingle = new Splide(singleProductSlider, {
      type: "fade",
      arrows: true,
      cover: true,
      arrows: false,
      focus: "center",
      rewind: true,
      pagination: true,
      perPage: 1,
      perMove: 1,
      mediaQuery: "min",
      breakpoints: {
        768: {
          pagination: false,
        },
      },
    }).mount();

    const thumbnailSliderSingle = new Splide(singleThumbnailProductSlider, {
      fixedWidth: 100,
      fixedHeight: 100,
      isNavigation: true,
      gap: 16,
      focus: "top",
      arrows: false,
      pagination: false,
      height: 300,
      direction: "ttb",
      cover: true,
      breakpoints: {
        600: {
          fixedWidth: 66,
          fixedHeight: 40,
        },
      },
    }).mount();

    productSliderSingle.sync(thumbnailSliderSingle);
  }

  if (latestPostsSlider) {
  
    const numberOfSlides = document.querySelectorAll('.latest-posts-slide').length;

    const latestPosts = new Splide(latestPostsSlider, {
      type: numberOfSlides > 3 ? "loop" : "slide",
      perPage: 1,
      perMove: 1,
      gap: 16,
      focus: 'left',
      rewind: true,
      arrows: false,
      pagination: true,
      mediaQuery: "min",
      breakpoints: {
        768: {
          perPage: Math.min(numberOfSlides, 3),
        },
        992: {
          gap: 24,
        },
        1920: {
          gap: 32,
        },
      },
      }).mount();
}
  
    if (archiveSlider) {
      const helpSlider = new Splide(archiveSlider, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: 16,
        focus: "center",
        rewind: true,
        arrows: false,
        pagination: true,
        mediaQuery: "min",
        breakpoints: {
          768: {
            perPage: 3,
            perMove: 3,
          },
          992: {
            gap: 24,
          },
          1920: {
            gap: 32,
          },
        },
      }).mount();
    }
  });
